import * as R from 'ramda';

export default function EditSchematicDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  bcpDataService,
  bcpSharedModelService,
  loaderService,
  ssDialogService
) {
  const vm = this;
  
  vm.isEdit = vm.schematic.assessmentSchematicId > 0;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSchematicFileAdd = _handleSchematicFileAdd;
  vm.handleEditSchematicFormSubmit = _handleEditSchematicFormSubmit;
  vm.selectedSection = null;

  _activate();

  function _handleCloseDialog() {
    _closeDialog();
  }

  // eslint-disable-next-line no-unused-vars
  function _handleSchematicFileAdd($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event) {
    // TODO: Add progress bar
  }

  function _handleEditSchematicFormSubmit() {
    if (_isValid()) {
      loaderService.showViewLoader = true;
      vm.schematic.schematicSectionId = vm.selectedSection.schematicSectionId;

      const justEditMetadata = vm.isEdit && !vm.schematic.file;
      const dfdSave = $q.defer();

      if (justEditMetadata) {
        // Just editing metadata, no upload needed
        bcpDataService.updateSchematic(vm.schematic).then(dfdSave.resolve);
      } else {
        // New file is supporting document
        bcpSharedModelService.uploadSchematic(vm.assessmentId, vm.schematic, vm.selectedSection.name).then(dfdSave.resolve);
      }

      dfdSave.promise.then(() => {
        alerts.success('The Schematic has been saved successfully.');

        $rootScope.$broadcast('setDocumentRegenerateFlag');
        $rootScope.$broadcast('refreshBCPSchematics');

        _closeDialog();
      });
    }
  }

  function _activate() {
    loaderService.showViewLoader = true;
    return bcpSharedModelService.getSchematicSections(true).then((schematicSections) => {
      loaderService.showViewLoader = false;
      vm.schematicSections = schematicSections;

      R.forEach((schematicSection) => {
        if (schematicSection.schematicSectionId === vm.schematic.schematicSectionId) {
          vm.selectedSection = schematicSection;
        }
      }, vm.schematicSections);
    });
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.editSchematicDialog);
  }

  function _isValid() {
    let isValid = true;
    
    if (vm.schematic.file || vm.schematic.documentId) {
      vm.documentPresent = true;
    } else {
      isValid = false;
      vm.documentPresent = false;
    }

    if ((vm.schematic.name === undefined) || (vm.schematic.name === null)) {
      isValid = false;
    }  

    return isValid;
  }
}

EditSchematicDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'bcpDataService',
  'bcpSharedModelService',
  'loaderService',
  'ssDialogService'
];
